import { render, staticRenderFns } from "./3.vue?vue&type=template&id=ecf92768&scoped=true&"
var script = {}
import style0 from "./3.vue?vue&type=style&index=0&id=ecf92768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf92768",
  null
  
)

export default component.exports